import './EntityUpdate.scss'
import React, { useEffect, useState } from 'react';
import AdminMainLayout from '../AdminMainLayout';
import ProductActionForm from './ProductActionForm';
import SpaceActionForm from './SpaceActionForm';
import SceneActionForm from './SceneActionForm';
import FailedAndAbortedJobs from './FailedAndAbortedJobs';
import { Tabs, Input, Card, Col } from "antd";
const { TabPane } = Tabs;
const EntityUpdate = () => {
    const [tabActiveKey, setTabActiveKey] = useState('product');
    const tabs = [
        {
          key: 'product',
          title: 'Product',
          Component: (() => {
            return (
            <ProductActionForm>
            </ProductActionForm>
            )
          })
        },
        {
          key: 'space',
          title: 'Space',
          Component: (() => {
            return (
                <SpaceActionForm>
                </SpaceActionForm>
                )
          })
        },
        {
          key: 'scene',
          title: 'Scene',
          Component: (() => {
            return (
                <SceneActionForm>
                </SceneActionForm>
                )
          })
        },
        {
          key: 'failed_and_aborted',
          title: 'Failed & Aborted',
          Component: (() => {
            return (
                <FailedAndAbortedJobs>
                </FailedAndAbortedJobs>
                )
          })
        }
      ];
    const handleTabChange = (key) => {
        setTabActiveKey(key);
    };
    return (
        <AdminMainLayout selected={'22'}>
            <Col span={24}>
                <Tabs
                onChange={(key) => handleTabChange(key)}
                tabBarGutter={16}
                size="large"
                activeKey={tabActiveKey}>
                    {
                        tabs?.map((tab) => {
                            return (
                                <TabPane tab={tab.title} key={tab.key} style={{ padding: "0px 10px" }}> 
                                {
                                    tab.Component()
                                }
                                </TabPane>
                            )
                        })
                    }  
                </Tabs>
            </Col>
        </AdminMainLayout>
    )
};
export default EntityUpdate;